'use strict';

var DataSourceTypeEnum;
(function (DataSourceTypeEnum) {
    DataSourceTypeEnum["INLINE"] = "inline";
    DataSourceTypeEnum["URL"] = "url";
})(DataSourceTypeEnum || (DataSourceTypeEnum = {}));
var DataSourceFormatEnum;
(function (DataSourceFormatEnum) {
    DataSourceFormatEnum["JSON"] = "json";
    DataSourceFormatEnum["CSV"] = "csv";
})(DataSourceFormatEnum || (DataSourceFormatEnum = {}));

var OperatorEnum;
(function (OperatorEnum) {
    OperatorEnum["ADD"] = "add";
    OperatorEnum["CROSSPRODUCT"] = "cross";
    OperatorEnum["UNION"] = "union";
    OperatorEnum["INTERSECT"] = "intersect";
    OperatorEnum["BIN"] = "bin";
    OperatorEnum["CONCAT"] = "concat";
    OperatorEnum["AVERAGE"] = "average";
    OperatorEnum["SUM"] = "sum";
    OperatorEnum["COUNT"] = "count";
    OperatorEnum["DESCSORT"] = "descsort";
    OperatorEnum["ASCSORT"] = "ascsort";
    OperatorEnum["BOUNDFILTER"] = "filterByBound";
    OperatorEnum["VALUEFILTER"] = "filterByValue";
    OperatorEnum["SPLIT"] = "split";
})(OperatorEnum || (OperatorEnum = {}));
var TokenTypeEnum;
(function (TokenTypeEnum) {
    TokenTypeEnum["Identifier"] = "Identifier";
    TokenTypeEnum["Punctuator"] = "Punctuator";
    TokenTypeEnum["Number"] = "Number";
})(TokenTypeEnum || (TokenTypeEnum = {}));

var isCSVArray = function (array) {
    return Array.isArray(array[0]);
};
var isJSONArray = function (array) {
    return array[0].toString().includes("object");
};
// 将 DataSource 解析成 DataTable：补全默认值、加载数据、构造 Table 等
// TODO：感觉需要加个 hash 索引，各属性值之间能方便对应上，但两个表 union 的时候会比较蛋疼
var DataTable = /** @class */ (function () {
    function DataTable(dataSource) {
        var _this = this;
        this.name = "";
        this.attributes = [];
        this.tuples = [];
        this.name = dataSource.name;
        var type = dataSource.type || (dataSource.values && !dataSource.url)
            ? DataSourceTypeEnum.INLINE
            : (!dataSource.values && dataSource.url)
                ? DataSourceTypeEnum.URL
                : undefined;
        if (!type)
            throw Error("undefined data source type.");
        if (type === DataSourceTypeEnum.URL) ;
        var format = dataSource.format || isCSVArray(dataSource.values)
            ? DataSourceFormatEnum.CSV
            : isJSONArray(dataSource.values)
                ? DataSourceFormatEnum.JSON
                : undefined;
        if (!format)
            throw Error("undefined data source format.");
        var values = [];
        var attrs = [];
        if (format === DataSourceFormatEnum.JSON) {
            attrs = Object.keys(dataSource.values[0]);
            // values.push(attrs);
            dataSource.values.forEach(function (dataObj) {
                var CSVLineArray = [];
                for (var _i = 0, attrs_1 = attrs; _i < attrs_1.length; _i++) {
                    var attr = attrs_1[_i];
                    var value = {
                        value: dataObj[attr],
                        table: _this.name,
                        attribute: attr,
                    };
                    CSVLineArray.push(value);
                }
                values.push(CSVLineArray);
            });
        }
        // this.tuples = values.slice(1);
        this.tuples = dataSource.values;
        this.attributes = attrs.map(function (attrName, index) {
            var valueList = [];
            values.forEach(function (tuple) {
                if (tuple[index].value != undefined) {
                    valueList.push(tuple[index]);
                }
            });
            var obj = {};
            valueList = valueList.reduce(function (item, next) {
                obj[next.value] ? "" : (obj[next.value] = item.push(next));
                return item;
            }, []);
            return {
                name: attrName,
                values: valueList,
            };
        });
        // console.log(JSON.stringify(this.attributes))
    }
    return DataTable;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var calcDimension = function (arr) {
    // let j = 1;
    // for (let i in arr) {
    //   if (arr[i] instanceof Array) {
    //     let d = calcDimension(arr[i]);
    //     if (1 + d > j) {
    //       j = 1 + d;
    //     }
    //   }
    // }
    // return j;
    if (!(arr instanceof Array) || arr.length == 0)
        return 0;
    if (arr instanceof Array) {
        if (arr[0] instanceof Array) {
            return arr[0].length;
        }
        else {
            return 1;
        }
    }
};
// 字符串化spec
var calString = function (spec) {
    if (!spec) {
        return "";
    }
    else if (typeof (spec.value) == "number") {
        return String(spec.value);
    }
    else if (typeof (spec.value) == "string") {
        return "'" + String(spec.value) + "'";
    }
    else if (spec.data) {
        return spec.data + "." + spec.attribute;
    }
    else {
        var res_1 = [];
        if (spec.parameters && spec.parameters.length > 0) {
            spec.parameters.forEach(function (item) {
                res_1.push(calString(item));
            });
        }
        if (spec.operator == "cross" || spec.operator == "add") {
            var tmp = res_1[0];
            for (var i = 1; i < res_1.length; i++) {
                tmp += " \u00D7 " + res_1[i];
            }
            return tmp;
        }
        else {
            var tmp = spec.operator + "(";
            for (var i = 0; i < res_1.length; i++) {
                if (i == 0) {
                    tmp = tmp + res_1[i];
                }
                else {
                    tmp = tmp + ", " + res_1[i];
                }
            }
            tmp = tmp + ")";
            return tmp;
        }
    }
};

var sum = function (numbers) {
    return numbers.reduce(function (total, num) { return total + num; });
};
var avg = function (numbers) {
    return sum(numbers) / numbers.length;
};
var count = function () { };
var add = function (set1, set2) {
    if (set1.length == 0)
        return set2;
    if (set2.length == 0)
        return set1;
    if (calcDimension(set1) != calcDimension(set2)) {
        throw new Error("Incompatible parameters for ADD operation");
    }
    if ("_" in set1 || "_" in set2) {
        set2.forEach(function (value) { return set1.push(value); });
    }
    else {
        throw new Error("Illegal parameters for Add operation");
    }
    return set1;
};
var cross = function (set1, set2) {
    var res = [];
    set1.forEach(function (value1) {
        set2.forEach(function (value2) {
            var tmp = [];
            if (value1 instanceof Array) {
                for (var i = 0; i < value1.length; i++) {
                    tmp.push(value1[i]);
                }
            }
            else {
                tmp.push(value1);
            }
            if (value2 instanceof Array) {
                for (var i = 0; i < value2.length; i++) {
                    tmp.push(value2[i]);
                }
            }
            else {
                tmp.push(value2);
            }
            res.push(tmp);
        });
    });
    return res;
};
var union = function (set1, set2) {
    // console.log("set1",set1);
    // console.log("set2", set2);
    if (calcDimension(set1) != calcDimension(set2)) {
        throw new Error("Incompatible parameters for UNION operation");
    }
    var valList = [];
    set1.forEach(function (obj) {
        valList.push(obj.value);
    });
    var unionSet = new Set(valList);
    var res = set1;
    set2.forEach(function (value) {
        if (!unionSet.has(value.value)) {
            res.push(value);
        }
    });
    return res;
};
var intersect = function (set1, set2) {
    if (calcDimension(set1) != calcDimension(set2)) {
        throw new Error("Incompatible parameters for INTERSECT operation");
    }
    var valList = [];
    set1.forEach(function (obj) {
        valList.push(obj.value);
    });
    var unionSet = new Set(valList);
    var res = [];
    set2.forEach(function (value) {
        if (unionSet.has(value.value)) {
            res.push(value);
        }
    });
    return res;
};
var bin = function (values, binNumber, lowerBound, upperBound) {
    if (binNumber <= 0) {
        throw new Error("The step of BIN is illegal");
    }
    var min, max, result = [];
    if (lowerBound && upperBound) {
        if (lowerBound > upperBound) {
            throw new Error("The lowerBound is bigger than upperBound");
        }
        min = lowerBound;
        max = upperBound;
    }
    else {
        if (values.length == 0) {
            throw new Error("The length of para 1 for BIN cannot be 0");
        }
        var valueList_1 = [];
        values.forEach(function (value) {
            valueList_1.push(value.value);
        });
        if (typeof valueList_1[0] != "number") {
            throw new Error("Parameter of BIN cannot be divided");
        }
        min = Math.min.apply(Math, valueList_1);
        max = Math.max.apply(Math, valueList_1);
    }
    var interval = (max - min) / binNumber;
    for (var i = 0; i < binNumber; i++) {
        result[i] = Object.assign({}, values[0]);
        result[i].value = {
            lower: min + i * interval,
            // upper: (i==binNumber-1)?Infinity:min+i*interval
            upper: min + (i + 1) * interval,
            isRightOpen: (i != binNumber - 1)
        };
    }
    return result;
};
var concat = function (set1, set2) {
    if (calcDimension(set1) != calcDimension(set2)) {
        throw new Error("Incompatible parameters for CONCAT operation");
    }
    var res = [];
    for (var i = 0; i < set1.length && i < set2.length; i++) {
        if (typeof (set1[i]) == "string" || typeof (set1[i]) == "number") {
            res.push(String(set1[i]).concat(String(set2[i])));
        }
        else {
            var newObj = Object.assign({}, set1[i]);
            newObj.value = String(set1[i].value).concat(String(set2[i].value));
            res.push(newObj);
        }
    }
    return res;
};
var ascsort = function (values) {
    var tmp = [];
    values.forEach(function (item) {
        tmp.push(item);
    });
    return tmp.sort(function (a, b) {
        if (typeof (a.value) != typeof (b.value)) {
            throw new Error("Sort error: incompatible data type");
        }
        else if (typeof (a.value) == "number") {
            return (a.value > b.value) ? 1 : -1;
        }
        else if (typeof (a.value) == "string") {
            return (a.value > b.value) ? 1 : -1;
        }
        else {
            throw new Error("Sort error: items cannot be sorted");
        }
    });
};
var descsort = function (values) {
    return ascsort(values).reverse();
};
var filterByValue = function (values, paras) {
    var tmp = [];
    var valueList = [];
    paras.forEach(function (item) {
        valueList.push(item.value);
    });
    values.forEach(function (item) {
        if (valueList.indexOf(item.value) != -1) {
            tmp.push(item);
        }
    });
    return tmp;
};
var filterByBound = function (values, lowerBound, upperBound) {
    // console.log("lb", lowerBound, upperBound);
    var tmp = [];
    values.forEach(function (item) {
        if (item.value >= lowerBound && item.value <= upperBound) {
            tmp.push(item);
        }
    });
    return tmp;
};
var Rsplit = function (values, pattern, index) {
    var ans = [];
    var dict = new Set();
    for (var i = 0; i < values.length; i++) {
        var originalString = void 0;
        if (typeof (values[i]) == "number" || typeof (values[i]) == "string") {
            originalString = String(values[i]);
            var tmp = originalString.split(pattern);
            if (!dict.has(String(tmp[index]))) {
                ans.push(String(tmp[index]));
                dict.add(String(tmp[index]));
            }
        }
        else {
            originalString = String(values[i].value);
            var tmp = originalString.split(pattern);
            var newObj = Object.assign({}, values[i]);
            newObj.value = tmp[index];
            if (!dict.has(String(tmp[index]))) {
                ans.push(newObj);
                dict.add(String(tmp[index]));
            }
        }
    }
    return ans;
};
var operators = { sum: sum, avg: avg, count: count, add: add, cross: cross, union: union, intersect: intersect, bin: bin, concat: concat, ascsort: ascsort, descsort: descsort, filterByValue: filterByValue, filterByBound: filterByBound, Rsplit: Rsplit };

var esprima = require('esprima');
var eps = 1e-6;
var digitUnicodeStart = 48;
var uppercaseLetterUnicodeStart = 65;
var lowercaseLetterUnicodeStart = 97;
var digits = new Array(10)
    .fill(0)
    .map(function (_, index) { return String.fromCharCode(digitUnicodeStart + index); });
var uppercaseLetters = new Array(26)
    .fill(0)
    .map(function (_, index) { return String.fromCharCode(uppercaseLetterUnicodeStart + index); });
var lowercaseLetters = new Array(26)
    .fill(0)
    .map(function (_, index) { return String.fromCharCode(lowercaseLetterUnicodeStart + index); });
__spreadArray(__spreadArray(__spreadArray([], uppercaseLetters, true), lowercaseLetters, true), [
    "_",
], false);
__spreadArray(__spreadArray(__spreadArray(__spreadArray([], digits, true), uppercaseLetters, true), lowercaseLetters, true), [
    "_",
], false);
// export const tokenizeExpression = (
//   expression: TargetTableExpression
// ): ExpressionToken[] => {
//   const tokens: ExpressionToken[] = [];
//   for (const c of expression) {
//     if (c.match(/\S/)) continue;
//     if (punctuatorCharacters.includes(c)) {
//       tokens.push({
//         type: TokenTypeEnum.Punctuator,
//         value: c,
//       });
//     } else if (identifierStartCharacters.includes(c)) {
//       // TODO
//     }
//   }
//   return tokens;
// };
var parseExpression = function (expression) {
    var pattern = /( )*\(.*\)( )*,( )*\(.*\)( )*=>( )*\(.*\)( )*/;
    var targetTableSyntax = {
        row_header: undefined,
        column_header: undefined,
        body: undefined
    };
    if (!pattern.test(expression)) {
        throw new Error("Illegal Expression!");
    }
    var i = 0; // current cursor
    var startPos, cnt;
    var flag; // 0: rowHeader 1: columnHeader 2: Body
    for (flag = 0; flag < 3; flag++) {
        while (i < expression.length && expression[i] != '(')
            i++;
        startPos = i;
        i++;
        cnt = 1;
        for (; i < expression.length; i++) {
            if (expression[i] == '(')
                cnt++;
            if (expression[i] == ')')
                cnt--;
            if (cnt == 0)
                break;
        }
        if (cnt != 0) {
            throw new Error("Illegal Expression!");
        }
        if (startPos + 1 < i) {
            var tokens = esprima.parseScript(expression.slice(startPos + 1, i));
            tokens = tokens.body[0].expression;
            switch (flag) {
                case 0:
                    targetTableSyntax.row_header = parseTokens(tokens);
                    break;
                case 1:
                    targetTableSyntax.column_header = parseTokens(tokens);
                    break;
                default:
                    targetTableSyntax.body = parseTokens(tokens);
                    break;
            }
        }
        else {
            switch (flag) {
                case 0:
                    targetTableSyntax.row_header = undefined;
                    break;
                case 1:
                    targetTableSyntax.column_header = undefined;
                    break;
                default:
                    targetTableSyntax.body = undefined;
                    break;
            }
        }
    }
    return targetTableSyntax;
};
var parseTokens = function (tokens) {
    // console.log("tokens:", tokens);
    if (tokens.type == "MemberExpression") {
        return {
            data: tokens.object.name,
            attribute: tokens.property.name
        };
    }
    else if (tokens.type == "BinaryExpression") {
        if (tokens.operator == "+") {
            return {
                operator: "add",
                parameters: [parseTokens(tokens.left), parseTokens(tokens.right)]
            };
        }
        else if (tokens.operator == "*") {
            return {
                operator: "cross",
                parameters: [parseTokens(tokens.left), parseTokens(tokens.right)]
            };
        }
        else {
            throw new Error("Illegal Expression!");
        }
    }
    else if (tokens.type == "CallExpression") {
        if (tokens.callee.name == "bin") {
            if (tokens.arguments.length == 2) {
                return {
                    operator: tokens.callee.name,
                    parameters: [parseTokens(tokens.arguments[0]), tokens.arguments[1]]
                };
            }
            else {
                return {
                    operator: tokens.callee.name,
                    parameters: [parseTokens(tokens.arguments[0]), tokens.arguments[1], tokens.arguments[2], tokens.arguments[3]]
                };
            }
        }
        else if (tokens.callee.name == "intersect" || tokens.callee.name == "union") {
            return {
                operator: tokens.callee.name,
                parameters: [parseTokens(tokens.arguments[0]), parseTokens(tokens.arguments[1])]
            };
        }
        else if (tokens.callee.name == OperatorEnum.VALUEFILTER) {
            var params = [parseTokens(tokens.arguments[0])];
            for (var i = 1; i < tokens.arguments.length; i++) {
                params.push(tokens.arguments[i]);
            }
            return {
                operator: tokens.callee.name,
                parameters: params
            };
        }
        else if (tokens.callee.name == OperatorEnum.BOUNDFILTER || tokens.callee.name == OperatorEnum.SPLIT) {
            return {
                operator: tokens.callee.name,
                parameters: [parseTokens(tokens.arguments[0]), tokens.arguments[1], tokens.arguments[2]]
            };
        }
        else if (tokens.callee.name == OperatorEnum.CONCAT && tokens.arguments.length > 1) {
            return {
                operator: tokens.callee.name,
                parameters: [parseTokens(tokens.arguments[0]), parseTokens(tokens.arguments[1])]
            };
        }
        else {
            return {
                operator: tokens.callee.name,
                parameters: [parseTokens(tokens.arguments[0])]
            };
        }
    }
    else {
        throw new Error("Illegal Expression!");
    }
};
var computeTargetTable = function (tables, syntaxTree) {
    // console.log("tables:");
    // console.log(tables);
    var targetTable = [];
    // if (syntaxTree.row_header && syntaxTree.column_header) {
    var rowList = parseHeader(tables, syntaxTree.row_header);
    var columnList = Object.assign([], parseHeader(tables, syntaxTree.column_header));
    if (rowList.length == 0) {
        throw new Error("Row header is empty!");
    }
    if (columnList.length == 0) {
        throw new Error("Column header is empty!");
    }
    // Body
    var cnt = 0;
    var bodyList = parseBody(syntaxTree.body);
    // console.log("body:");
    if (columnList.length == 1 && columnList[0] === "_") { // feat: 当rowHeader（或columnHeader）为空时，按照body内attr的数量填充"_"
        for (var i = 0; i < bodyList.length - 1; i++) {
            columnList.push("_");
        }
    }
    if (rowList.length == 1 && rowList[0] === "_") {
        for (var i = 0; i < bodyList.length - 1; i++) {
            rowList.push("_");
        }
    }
    // Handle Row Header and Column Header
    var rowDim = calcDimension(rowList);
    var columnDim = calcDimension(columnList);
    var rowSize = rowList.length;
    var columnSize = columnList.length;
    if (columnDim > 1) {
        columnList.forEach(function (value, index, arr) {
            arr[index] = [].concat.apply([], value);
        });
    }
    else {
        for (var i = 0; i < columnList.length; i++) {
            columnList[i] = [columnList[i]];
        }
    }
    if (rowDim > 1) {
        rowList.forEach(function (value, index, arr) {
            arr[index] = [].concat.apply([], value);
        });
    }
    //transpose
    columnList = columnList[0].map(function (col, i) {
        return columnList.map(function (row) {
            return row[i];
        });
    });
    for (var i = 0; i < columnDim; i++) {
        var tmp = [];
        for (var j = 0; j < rowDim; j++) {
            tmp.push(null);
        }
        targetTable.push(tmp.concat(columnList[i]));
    }
    rowList.forEach(function (value) {
        if (value instanceof Array) {
            targetTable.push(value);
        }
        else {
            targetTable.push([value]);
        }
    });
    // console.log("before parsing body:");
    // console.log(targetTable);
    // console.log(parseHeader(tables, {
    //   data: "crime",
    //   attribute: "year",
    // }))
    // console.log(parseHeader(tables, {
    //   data: "crime",
    //   attribute: "state",
    // }))
    //Handle Body
    if (bodyList[0] === "_") {
        for (var i = columnDim; i < columnDim + rowSize; i++) {
            for (var j = rowDim; j < rowDim + columnSize; j++) {
                targetTable[i][j] = null;
            }
        }
        for (var i = columnDim; i < columnDim + rowSize; i++) {
            if (typeof (targetTable[i][0]) == "string" && targetTable[i][0] == "_") {
                targetTable[i][0] = null;
            }
        }
        for (var i = rowDim; i < rowDim + columnSize; i++) {
            if (typeof (targetTable[0][i]) == "string" && targetTable[0][i] == "_") {
                targetTable[0][i] = null;
            }
        }
        return targetTable;
    }
    var queryAttr;
    var defaultQueryAttr = -1;
    var rowDict = [], columnDict = []; // 对于初始为"_"的rowHeader，rowDict[i]记录第i行的rowHeader最后被修改为了哪一个attr（bodyList的数组下标），columnHeader同
    for (var i_1 = 0; i_1 < columnDim + rowSize; i_1++) {
        rowDict.push(-1);
    }
    for (var i = 0; i < rowDim + columnSize; i++) {
        columnDict.push(-1);
    }
    // for (var j = rowDim; j < rowDim + columnSize; j++) {
    //   if(typeof(targetTable[0][j]) == "string" && targetTable[0][j] == "_"){
    //     let tmp: TargetTableAttribute = bodyList[cnt++];
    //     targetTable[0][j] = tmp;
    //   }
    // }
    // for (var i = columnDim; i < columnDim + rowSize; i++) {
    //   if(typeof(targetTable[i][0]) == "string" && targetTable[i][0] == "_"){
    //     let tmp: TargetTableAttribute = bodyList[cnt++];
    //     targetTable[i][0] = tmp;
    //   }
    // }
    for (var i = columnDim; i < columnDim + rowSize; i++) {
        for (var j = rowDim; j < rowDim + columnSize; j++) {
            var constraints = [];
            for (var k = 0; k < rowDim; k++) {
                if (typeof targetTable[i][k] != "string") {
                    constraints.push(targetTable[i][k]);
                }
            }
            for (var k = 0; k < columnDim; k++) {
                if (typeof targetTable[k][j] != "string") {
                    constraints.push(targetTable[k][j]);
                }
            }
            var flag = 0; //用于去除该单元格对应的行和列都为placeholder且attr不同的情况
            if (typeof targetTable[0][j] == "string" && targetTable[0][j] == "_") {
                var tmp = bodyList[cnt];
                columnDict[j] = cnt++;
                if (isAttribute(tmp)) {
                    targetTable[0][j] = tmp.attribute;
                }
                else {
                    var newTmp = tmp;
                    targetTable[0][j] = calString(newTmp);
                }
                flag = 1;
            }
            if (typeof targetTable[i][0] == "string" && targetTable[i][0] == "_") {
                var tmp = bodyList[cnt];
                rowDict[i] = cnt++;
                if (isAttribute(tmp)) {
                    targetTable[i][0] = tmp.attribute;
                }
                else {
                    var newTmp = tmp;
                    targetTable[i][0] = calString(newTmp);
                }
                if (flag && bodyList[columnDict[j]] != tmp) {
                    throw new Error("Selected attribute conflict for " + JSON.stringify(bodyList[columnDict[j]]) + " and " + JSON.stringify(tmp));
                }
                flag = 1;
            }
            if (!flag && columnDict[j] == -1 && rowDict[i] == -1 && defaultQueryAttr == -1) {
                defaultQueryAttr = cnt++;
            }
            // console.log("row:", rowDict[i]);
            // console.log("col:", columnDict[j]);
            // console.log("def:", defaultQueryAttr)
            if (columnDict[j] != -1) {
                queryAttr = bodyList[columnDict[j]];
            }
            else if (rowDict[i] != -1) {
                queryAttr = bodyList[rowDict[i]];
            }
            else {
                queryAttr = bodyList[defaultQueryAttr];
            }
            // console.log("queryAttr:", queryAttr);
            var resTmp = queryTable(constraints, queryAttr, tables);
            // console.log("here", resTmp);
            var finalValue = void 0;
            if (resTmp.length > 1) {
                finalValue = "";
                for (var i_2 = 0; i_2 < resTmp.length; i_2++) {
                    if (i_2)
                        finalValue += ",";
                    finalValue += String(resTmp[i_2]);
                }
            }
            else if (resTmp.length == 1) {
                finalValue = resTmp[0];
            }
            else {
                finalValue = null;
            }
            targetTable[i][j] = {
                value: finalValue,
                source: queryAttr,
            };
        }
    }
    // 给row_header 和 column_header 加上source
    for (var i = columnDim; i < columnDim + rowSize; i++) {
        for (var j = 0; j < rowDim; j++) {
            if (!targetTable[i][j] || !targetTable[i][j].value || targetTable[i][j].value == "")
                continue;
            targetTable[i][j] = {
                value: targetTable[i][j].value,
                source: {
                    data: targetTable[i][j].table,
                    attribute: targetTable[i][j].attribute
                }
            };
        }
    }
    for (var i = 0; i < columnDim; i++) {
        for (var j = rowDim; j < rowDim + columnSize; j++) {
            if (!targetTable[i][j] || !targetTable[i][j].value || targetTable[i][j].value == "")
                continue;
            targetTable[i][j] = {
                value: targetTable[i][j].value,
                source: {
                    data: targetTable[i][j].table,
                    attribute: targetTable[i][j].attribute
                }
            };
        }
    }
    return targetTable;
};
var isAttribute = function (spec) {
    return (spec.data !== undefined &&
        spec.attribute !== undefined);
};
var isOperator = function (spec) {
    return (spec.operator !== undefined &&
        spec.parameters !== undefined);
};
var isValue = function (spec) {
    return spec.value !== undefined;
};
var getAttribute = function (tables, tableName, attributeName) {
    var table = tables.find(function (table) { return table.name === tableName; });
    if (!table)
        throw new Error("No such table name: " + tableName);
    var attribute = table.attributes.find(function (attribute) { return attribute.name === attributeName; });
    if (!attribute)
        throw new Error("No such attribute name: " + attributeName);
    return attribute;
};
var parseHeader = function (tables, header) {
    // console.log("header");
    // console.log(header);
    if (typeof header == "undefined" || header === null) {
        return ["_"];
    }
    var targetList = [];
    if (isAttribute(header)) {
        var attr = getAttribute(tables, header.data, header.attribute);
        targetList = attr.values;
        // console.log("targetList:")
        // console.log(targetList)
    }
    else if (isOperator(header)) {
        var op = header.operator;
        var para = header.parameters;
        if (op === OperatorEnum.BIN) {
            if (para.length != 2 && para.length != 4) {
                throw new Error("Too few or too many parameters for BIN");
            }
            else if (!isValue(para[1])) {
                throw new Error("Parameter 2 of BIN is illegal value");
            }
            else {
                var attrValue = parseHeader(tables, para[0]);
                var divNumber = para[1].value;
                var lowerBound = undefined, upperBound = undefined;
                if (para.length > 2) {
                    lowerBound = para[2].value;
                    upperBound = para[3].value;
                }
                targetList = operators.bin(attrValue, typeof divNumber == "string" ? parseInt(divNumber) : Number(divNumber), lowerBound, upperBound);
            }
        }
        else if (op == OperatorEnum.ASCSORT) {
            var attrValue = parseHeader(tables, para[0]);
            targetList = operators.ascsort(attrValue);
        }
        else if (op == OperatorEnum.DESCSORT) {
            var attrValue = parseHeader(tables, para[0]);
            targetList = operators.descsort(attrValue);
        }
        else if (op == OperatorEnum.VALUEFILTER) {
            var attrValue = parseHeader(tables, para[0]);
            var tmp = para.slice(1);
            targetList = operators.filterByValue(attrValue, tmp);
        }
        else if (op == OperatorEnum.BOUNDFILTER) {
            var attrValue = parseHeader(tables, para[0]);
            targetList = operators.filterByBound(attrValue, para[1].value, para[2].value);
        }
        else if (op == OperatorEnum.SPLIT) {
            var attrValue = parseHeader(tables, para[0]);
            targetList = operators.Rsplit(attrValue, para[1].value, para[2].value);
        }
        else {
            if (para.length != 2) {
                throw new Error("Too few or too many parameters for " + op);
            }
            else {
                var leftList = isValue(para[0])
                    ? [para[0]]
                    : parseHeader(tables, para[0]);
                var rightList = isValue(para[1])
                    ? [para[1]]
                    : parseHeader(tables, para[1]);
                if (op === OperatorEnum.UNION) {
                    targetList = operators.union(leftList, rightList);
                }
                else if (op === OperatorEnum.INTERSECT) {
                    targetList = operators.intersect(leftList, rightList);
                }
                else if (op === OperatorEnum.CROSSPRODUCT) {
                    targetList = operators.cross(leftList, rightList);
                }
                else if (op === OperatorEnum.ADD) {
                    targetList = operators.add(leftList, rightList);
                }
                else if (op === OperatorEnum.CONCAT) {
                    targetList = operators.concat(leftList, rightList);
                }
            }
        }
    }
    return targetList;
};
var parseBody = function (body) {
    if (typeof body == "undefined" || body === null) {
        return ["_"];
    }
    if (isAttribute(body))
        return [body];
    var op = body.operator;
    var paras = body.parameters;
    if (op == OperatorEnum.ADD) {
        if (paras.length != 2) {
            throw new Error("Too few or too many parameters for " + op);
        }
        if (isValue(paras[0])) {
            throw new Error("Body: Type Error for " + paras[0]);
        }
        if (isValue(paras[1])) {
            throw new Error("Body: Type Error for " + paras[1]);
        }
        var leftList = parseBody(paras[0]);
        var rightList = parseBody(paras[1]);
        return leftList.concat(rightList);
    }
    else {
        return [body];
    }
};
var queryTable = function (constraints, body, tables) {
    // let queryAttr: TargetTableAttribute = isAttribute(body)
    //   ? body
    //   : body.parameters[0] as TargetTableAttribute;
    // console.log("queryAttr:", queryAttr)
    if (isAttribute(body)) {
        var queryAttr_1 = body;
        var res_1 = [];
        var originTable = tables.find(function (table) { return table.name == queryAttr_1.data; });
        originTable.tuples.forEach(function (tuple) {
            var ok = true;
            constraints.forEach(function (constraint) {
                var key = constraint.attribute, value = constraint.value;
                // console.log(tuple[key], value);
                if (typeof (value) == "object") { //bin产生的区间，包括lower和upper 
                    if (value.isRightOpen) {
                        if (!(tuple[key] >= value.lower - eps && tuple[key] < value.upper - eps)) {
                            ok = false;
                        }
                    }
                    else {
                        if (!(tuple[key] >= value.lower - eps && tuple[key] <= value.upper + eps)) {
                            ok = false;
                        }
                    }
                }
                else if ((typeof (tuple[key]) == "string" && typeof (value) == "number") || (typeof (tuple[key]) == "number" && typeof (value) == "string")) {
                    ok = (String(tuple[key]) == String(value));
                }
                else {
                    ok = ok && (tuple[key] == value);
                }
            });
            if (ok) {
                if (tuple[queryAttr_1.attribute] != undefined)
                    res_1.push(tuple[queryAttr_1.attribute]);
            }
        });
        return Array.from(new Set(res_1));
    }
    else {
        if (body.operator == OperatorEnum.AVERAGE) {
            var res = queryTable(constraints, (body.parameters[0]), tables);
            if (res.length == 0) {
                return null;
            }
            var sum_1 = 0;
            res.forEach(function (obj) {
                if (typeof obj != "number") {
                    throw new Error("type error for average");
                }
                sum_1 += Number(obj);
            });
            return [sum_1 / res.length];
        }
        else if (body.operator == OperatorEnum.SUM) {
            var res = queryTable(constraints, (body.parameters[0]), tables);
            if (res.length == 0) {
                return null;
            }
            var sum_2 = 0;
            res.forEach(function (obj) {
                if (typeof obj != "number") {
                    throw new Error("type error for average");
                }
                sum_2 += Number(obj);
            });
            return [sum_2];
        }
        else if (body.operator == OperatorEnum.COUNT) {
            var res = queryTable(constraints, (body.parameters[0]), tables);
            return [res.length];
        }
        else if (body.operator == OperatorEnum.SPLIT) {
            var res = queryTable(constraints, (body.parameters[0]), tables);
            if (res.length) {
                var pattern = body.parameters[1];
                var index = body.parameters[2];
                return String(res[0]).split(String(pattern.value))[index.value];
            }
            else {
                return [];
            }
        }
        else if (body.operator == OperatorEnum.CONCAT) {
            if (body.parameters.length == 1) {
                var res = queryTable(constraints, (body.parameters[0]), tables);
                var ans_1 = "";
                res.forEach(function (obj) {
                    ans_1 += String(obj);
                });
                return [ans_1];
            }
            else {
                var res1 = queryTable(constraints, (body.parameters[0]), tables);
                var res2 = queryTable(constraints, (body.parameters[1]), tables);
                // console.log("!!!", res1, res2);
                if (res1.length && res2.length) {
                    var res = [];
                    for (var i = 0; i < res1.length && i < res2.length; i++) {
                        res.push(String(res1[i]).concat(String(res2[i])));
                    }
                    for (var i = res2.length; i < res1.length; i++) {
                        res.push(String(res1[i]).concat(String(res2[i])));
                    }
                    for (var i = res1.length; i < res2.length; i++) {
                        res.push(String(res1[i]).concat(String(res2[i])));
                    }
                    return res;
                }
                else if (res1.length && !res2.length) {
                    return res1;
                }
                else if (!res1.length && res2.length) {
                    return res2;
                }
                else {
                    return [];
                }
            }
        }
        else if (body.operator == OperatorEnum.UNION) {
            var res1 = queryTable(constraints, (body.parameters[0]), tables);
            var res2 = queryTable(constraints, (body.parameters[1]), tables);
            console.log("!!!", res1, res2);
            if (res1.length && res2.length) {
                var res = [];
                var s = {};
                for (var i = 0; i < res1.length; i++) {
                    res.push(res1[i]);
                    s[res1[i]] = true;
                }
                for (var i = 0; i < res2.length; i++) {
                    if (!s[res2[i]]) {
                        res.push(res2[i]);
                        s[res2[i]] = true;
                    }
                }
                return res;
            }
            else if (res1.length && !res2.length) {
                return res1;
            }
            else if (!res1.length && res2.length) {
                return res2;
            }
            else {
                return [];
            }
        }
        else if (body.operator == OperatorEnum.INTERSECT) {
            var res1 = queryTable(constraints, (body.parameters[0]), tables);
            var res2 = queryTable(constraints, (body.parameters[1]), tables);
            if (res1.length && res2.length) {
                var res = [];
                var s = {};
                for (var i = 0; i < res1.length; i++) {
                    s[res1[i]] = true;
                }
                for (var i = 0; i < res2.length; i++) {
                    if (s[res2[i]]) {
                        res.push(res2[i]);
                    }
                }
                return res;
            }
            else if (res1.length && !res2.length) {
                return res1;
            }
            else if (!res1.length && res2.length) {
                return res2;
            }
            else {
                return [];
            }
        }
        else {
            throw new Error("illegal operator");
        }
        // let res_all = [];
        // body.parameters.forEach(para => {
        //   let queryAttr = para as TargetTableAttribute;
        //   let res = [];
        //   let originTable = tables.find((table) => table.name == queryAttr.data);
        //   if(!originTable) return;
        //   originTable.tuples.forEach((tuple) => {
        //     let ok = true;
        //     constraints.forEach(constraint => {
        //       let key = constraint.attribute, value = constraint.value;
        //       if (typeof (value) == "object") { //bin产生的区间，包括lower和upper 
        //         if (value.isRightOpen) {
        //           if (!(tuple[key] >= value.lower - eps && tuple[key] < value.upper - eps)) {
        //             ok = false;
        //           }
        //         } else {
        //           if (!(tuple[key] >= value.lower - eps && tuple[key] <= value.upper + eps)) {
        //             ok = false;
        //           }
        //         }
        //       } else if (tuple[key] != value) {
        //         ok = false;
        //       }
        //     });
        //     if (ok) {
        //       res.push(tuple[queryAttr.attribute]);
        //     }
        //   });
        //   res_all.push(res);
        // });
        // if ((body as TargetTableOperator).operator == OperatorEnum.AVERAGE) {
        //   if (res_all[0].length == 0) {
        //     return null;
        //   }
        //   let sum = 0;
        //   res_all[0].forEach((obj) => {
        //     if (typeof obj != "number") {
        //       throw new Error("type error for average");
        //     }
        //     sum += Number(obj);
        //   });
        //   return sum / res_all[0].length;
        // } else if ((body as TargetTableOperator).operator == OperatorEnum.SUM) {
        //   if (res_all[0].length == 0) {
        //     return null;
        //   }
        //   let sum = 0;
        //   res_all[0].forEach((obj) => {
        //     if (typeof obj != "number") {
        //       throw new Error("type error for average");
        //     }
        //     sum += Number(obj);
        //   });
        //   return sum;
        // } else if ((body as TargetTableOperator).operator == OperatorEnum.COUNT) {
        //   return res_all[0].length;
        // } else if ((body as TargetTableOperator).operator == OperatorEnum.SPLIT) {
        //   console.log(res_all[0]);
        //   if(res_all[0].length) {
        //     let pattern = (body as TargetTableOperator).parameters[1] as OperatorValueParameter;
        //     let index = (body as TargetTableOperator).parameters[2] as OperatorValueParameter;
        //     return String(res_all[0][0]).split(String(pattern.value))[index.value]; 
        //   }
        // } else if ((body as TargetTableOperator).operator == OperatorEnum.CONCAT) {
        //   if(body.parameters.length == 1){
        //     let ans = "";
        //     res_all[0].forEach((obj) => {
        //       ans += String(obj);
        //     });
        //     return ans;
        //   } else {
        //     let arg1 = res_all[0], arg2 = res_all[1];
        //     if(arg1.length && arg2.length) {
        //       return String(arg1[0]).concat(String(arg2[0]));
        //     } else if(arg1.length && !arg2.length) {
        //       return String(arg1[0]);
        //     } else if(!arg1.length && arg2.length) {
        //       return String(arg2[0]);
        //     } else {
        //       return null;
        //     }
        //   }
        // } else {
        //   throw new Error("illegal operator");
        // }
    }
};

var transform = function (spec) {
    var tables = spec.data.map(function (dataSource) { return new DataTable(dataSource); });
    return spec.target_table.map(function (targetTable) {
        var syntaxTree;
        if (typeof targetTable === "string") {
            // const tokens: ExpressionToken[] = tokenizeExpression(targetTable);
            // syntaxTree = parseTokens(tokens);
            syntaxTree = parseExpression(targetTable);
        }
        else {
            syntaxTree = targetTable;
        }
        // TODO: 加一个 check 环节
        return computeTargetTable(tables, syntaxTree);
    });
};
var explore = function () { };
var prettyPrint = function (r) {
    var t = Object.assign([], r);
    return modifyStyle(t);
};
var modifyStyle = function (t) {
    if (t === null)
        return null;
    if (t instanceof Array) {
        for (var i = 0; i < t.length; i++) {
            t[i] = modifyStyle(t[i]);
        }
    }
    else {
        if (typeof (t) == "object") {
            if (t.value && typeof (t.value) == "object") {
                t = "[" + t.value.lower + ", " + t.value.upper + (t.value.isRightOpen ? ")" : "]");
            }
            else {
                t = t.value;
            }
        }
    }
    return t;
};
var index = {
    transform: transform,
    explore: explore,
    prettyPrint: prettyPrint
};

module.exports = index;
